<div class="admin-modal create-system-account-modal">
  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">Create new System Account</h3>
    <div class="header-actions">
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- Body -->
  <div class="modal-body">
    @if (loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
}

    @if (!loading) {
<form #createForm="ngForm" novalidate>

      <!-- Section 1: Account fields -->
      <div class="panel panel-default">
        <div class="panel-body">
          <div class="row equal-cols">
            <div class="col">
              <label>Account:</label>
              <input type="text" class="form-control" name="account_name"
                     placeholder="enter account"
                     [(ngModel)]="newSysAccount"
                     [class.color-background-red-light]="showAcctError" required>
              @if (showAcctError) {
<span class="form-error-container">Account is required.</span>
}
            </div>

            <div class="col col-wide">
              <label>Account Description:</label>
              <textarea class="form-control input-sm" name="account_desc"
                        [(ngModel)]="newSysAccountDesc"
                        [class.color-background-red-light]="showAcctDescError"
                        placeholder="Account description"></textarea>
              @if (showAcctDescError) {
<span class="form-error-container">Account Description is required.</span>
}
            </div>

            <div class="col">
              <label>Account type:</label>
              <ap-dropdown class="field-full-width" [list]="accountTypeItems" [selectType]="'single'"
                [title]="'Account type'" [hideTitleOnInput]="true" [inputAriaLabel]="'Account type'"
                [(ngModel)]="selectedAcctTypeItem" name="account_type" (onSelect)="onAcctTypeSelect($event)">
                @for (item of accountTypeItems; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'Account type')"
                    (onSelectItem)="onDropdownSelectItem($event, {current: selectedAcctTypeItem})"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>

            <div class="col">
              <label>Source System:</label>
              <ap-dropdown class="field-full-width" [list]="sourceSystemItems" [selectType]="'single'"
                [title]="'Source System'" [hideTitleOnInput]="true" [inputAriaLabel]="'Source System'"
                [(ngModel)]="selectedSourceSystemItem" name="source_system" (onSelect)="onSourceSystemSelect($event)">
                @for (item of sourceSystemItems; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'Source System')"
                    (onSelectItem)="onDropdownSelectItem($event, {current: selectedSourceSystemItem})"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>

            <div class="col">
              <label>System Chart:</label>
              <ap-dropdown class="field-full-width" [list]="sysChartItems" [selectType]="'single'"
                [title]="'System Chart'" [hideTitleOnInput]="true" [inputAriaLabel]="'System Chart'"
                [(ngModel)]="selectedSysChartItem" name="system_chart" (onSelect)="onSysChartSelect($event)">
                @for (item of sysChartItems; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'System Chart')"
                    (onSelectItem)="onDropdownSelectItem($event, {current: selectedSysChartItem})"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 2: Create from -->
      <div class="panel panel-default">
        <div class="panel-body">
          <div class="row create-from-row">
            <div class="col col-create-from">
              <label>Create from:</label>
              <ap-dropdown class="field-full-width" [list]="createFromItems" [selectType]="'single'"
                [title]="'Create from'" [hideTitleOnInput]="true" [inputAriaLabel]="'Create from'"
                [(ngModel)]="selectedCreateFromItem" name="create_from" (onSelect)="onCreateFromSelect($event)">
                @for (item of createFromItems; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'Create from')"
                    (onSelectItem)="onDropdownSelectItem($event, {current: selectedCreateFromItem})"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>

            <!-- fromExistingSysAcct: searchable dropdown of existing system accounts.
                 The list can be very large (Tax Sensitive accounts), so virtualScroll is enabled. -->
            @if (createFrom === 'fromExistingSysAcct') {
<div class="col col-tax-sens">
              <label>Tax Sensitive/System Account:</label>
              <ap-dropdown class="field-full-width" [list]="fromSystemAcctItems" [selectType]="'single'"
                [title]="'Tax Sensitive/System Account'" [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Sensitive/System Account'"
                [(ngModel)]="selectedFromSystemAcctItem" name="from_system_acct" (onSelect)="onFromSystemAcctSelect($event)">
                @for (item of fromSystemAcctItems; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'System Account')"
                    (onSelectItem)="onDropdownSelectItem($event, {current: selectedFromSystemAcctItem})"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>
}
          </div>

          <!-- fromNewFormMapping: cascading dropdown rows -->
          @if (createFrom === 'fromNewFormMapping') {

            @for (formLine of formLineMapping; track $index; let i = $index; let last = $last) {
<div class="row form-line-row">
              <div class="col">
                <label>IRS Form</label>
                <ap-dropdown class="field-full-width" [list]="formLookupItems" [selectType]="'single'"
                  [title]="'IRS Form'" [hideTitleOnInput]="true" [inputAriaLabel]="'IRS Form'"
                  [ngModel]="getRowSelectedItem(loadLookupForm, formLine.form)" [name]="'form_' + i"
                  (onSelect)="onRowPrimitiveSelect($event, formLine, 'form', i)">
                  @for (item of formLookupItems; track $index) {
                    <ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setDropdownAriaLabel(item, 'IRS Form')"
                      (onSelectItem)="onDropdownSelectItem($event, {current: null})"></ap-dropdown-list-item>
                  }
                </ap-dropdown>
              </div>

              <div class="col">
                <label>Schedule</label>
                <ap-dropdown class="field-full-width" [list]="getRowLookupItems(scheduleLookup[i])" [selectType]="'single'"
                  [title]="'Schedule'" [hideTitleOnInput]="true" [inputAriaLabel]="'Schedule'"
                  [disabled]="!formLine.form"
                  [ngModel]="getRowSelectedItem(scheduleLookup[i], formLine.schedule)" [name]="'schedule_' + i"
                  (onSelect)="onRowPrimitiveSelect($event, formLine, 'schedule', i)">
                  @for (item of getRowLookupItems(scheduleLookup[i]); track $index) {
                    <ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setDropdownAriaLabel(item, 'Schedule')"
                      (onSelectItem)="onDropdownSelectItem($event, {current: null})"></ap-dropdown-list-item>
                  }
                </ap-dropdown>
              </div>

              <div class="col col-form-line">
                <label>Line</label>
                <ap-dropdown class="field-full-width" [list]="getRowLookupItems(lineLookup[i])" [selectType]="'single'"
                  [title]="'Line'" [hideTitleOnInput]="true" [inputAriaLabel]="'Line'"
                  [disabled]="!formLine.schedule"
                  [ngModel]="getRowSelectedItem(lineLookup[i], formLine.line)" [name]="'line_' + i"
                  (onSelect)="onRowPrimitiveSelect($event, formLine, 'line', i)">
                  @for (item of getRowLookupItems(lineLookup[i]); track $index) {
                    <ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setDropdownAriaLabel(item, 'Line')"
                      (onSelectItem)="onDropdownSelectItem($event, {current: null})"></ap-dropdown-list-item>
                  }
                </ap-dropdown>
              </div>

              <div class="col">
                <label>Column</label>
                <ap-dropdown class="field-full-width" [list]="getRowLookupItems(columnLookup[i])" [selectType]="'single'"
                  [title]="'Column'" [hideTitleOnInput]="true" [inputAriaLabel]="'Column'"
                  [disabled]="!formLine.line"
                  [ngModel]="getRowSelectedItem(columnLookup[i], formLine.column)" [name]="'column_' + i"
                  (onSelect)="onRowPrimitiveSelect($event, formLine, 'column', i)">
                  @for (item of getRowLookupItems(columnLookup[i]); track $index) {
                    <ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setDropdownAriaLabel(item, 'Column')"
                      (onSelectItem)="onDropdownSelectItem($event, {current: null})"></ap-dropdown-list-item>
                  }
                </ap-dropdown>
              </div>

              <div class="col">
                <label>Section</label>
                <ap-dropdown class="field-full-width" [list]="getRowLookupItems(sectionLookup[i])" [selectType]="'single'"
                  [title]="'Section'" [hideTitleOnInput]="true" [inputAriaLabel]="'Section'"
                  [disabled]="!formLine.column"
                  [ngModel]="getRowSelectedItem(sectionLookup[i], formLine.section)" [name]="'section_' + i"
                  (onSelect)="onRowPrimitiveSelect($event, formLine, 'section', i)">
                  @for (item of getRowLookupItems(sectionLookup[i]); track $index) {
                    <ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setDropdownAriaLabel(item, 'Section')"
                      (onSelectItem)="onDropdownSelectItem($event, {current: null})"></ap-dropdown-list-item>
                  }
                </ap-dropdown>
              </div>

              <div class="col">
                <label>Part</label>
                <ap-dropdown class="field-full-width" [list]="getRowLookupItems(partLookup[i])" [selectType]="'single'"
                  [title]="'Part'" [hideTitleOnInput]="true" [inputAriaLabel]="'Part'"
                  [disabled]="!formLine.section"
                  [ngModel]="getRowSelectedItem(partLookup[i], formLine.part)" [name]="'part_' + i"
                  (onSelect)="onRowPrimitiveSelect($event, formLine, 'part', i)">
                  @for (item of getRowLookupItems(partLookup[i]); track $index) {
                    <ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setDropdownAriaLabel(item, 'Part')"
                      (onSelectItem)="onDropdownSelectItem($event, {current: null})"></ap-dropdown-list-item>
                  }
                </ap-dropdown>
              </div>

              <div class="col">
                <label>Form Chart:</label>
                <ap-dropdown class="field-full-width" [list]="formChartItems" [selectType]="'single'"
                  [title]="'Form Chart'" [hideTitleOnInput]="true" [inputAriaLabel]="'Form Chart'"
                  [ngModel]="findDropdownItemByValue(formChartItems, formLine.form_chart_key)" [name]="'form_chart_' + i"
                  (onSelect)="onFormChartSelect($event, formLine)">
                  @for (item of formChartItems; track $index) {
                    <ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setDropdownAriaLabel(item, 'Form Chart')"
                      (onSelectItem)="onDropdownSelectItem($event, {current: null})"></ap-dropdown-list-item>
                  }
                </ap-dropdown>
              </div>

              @if (last) {
<div class="col col-add add-row-cell">
                <label>Add New Form Line:</label>
                <div>
                  <i class="fa fa-plus-circle add-icon"
                     (click)="addNewFormLineMapping()"></i>
                </div>
              </div>
}
            </div>
}
          
}
        </div>
      </div>

      <!-- Section 3: Client specific -->
      <div class="panel panel-default">
        <div class="panel-body">
          <div class="row client-row">
            <div class="col-md-3 client-toggle">
              <ap-checkbox name="client_specific" inputId="cs_create"
                          [(ngModel)]="isClientSpecific"
                          [ariaLabel]="'Is client specific'">
              </ap-checkbox>
              <label for="cs_create">Is client specific</label>
            </div>

            @if (isClientSpecific) {
<div class="col-md-3">
              <label>Select Client:</label>
              <ap-dropdown name="clients_create"
                             [list]="clientDropdownList"
                             [(ngModel)]="selectedClientList"
                             [selectType]="'multiple'"
                             [enableNgContent]="false"
                             [optionName]="'label'"
                             [optionValue]="'id'"
                             [title]="'Select clients'"
                             [inputAriaLabel]="'Select Client'"
                             [hideTitleOnInput]="true"
                             [showSearchbox]="false"
                             [showSelectAll]="true"
                             style="width:100%"
                             (onSelect)="onClientListChange()">
              </ap-dropdown>
            </div>
}

            @if (isClientSpecific) {
<div class="col-md-6">
              <div class="entitie-holder">
                @for (entity of selectedClientList; track $index; let i = $index) {
<div class="btn-group">
                  <button type="button" class="btn btn-xs btn-default">{{ entity.label }}</button>
                  <button type="button"
                          class="btn btn-xs btn-danger"
                          (click)="removeClient(i)">
                    <span class="fa fa-times"></span>
                  </button>
                </div>
}
              </div>
            </div>
}
          </div>
        </div>
      </div>
    </form>
}
  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <button class="btn btn-success btn-sm" type="button" (click)="save()" [disabled]="crudLoading">
      @if (crudLoading) {
<i class="fa fa-spinner fa-pulse"></i>
} Save
    </button>
    <button class="btn btn-reset btn-sm" type="button" (click)="reset()">Reset</button>
    <button class="btn btn-danger btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
